<section class="page-surface p-6 lg:p-8">
  <h2 class="text-lg font-semibold text-slate-700 underline underline-offset-4">
    Required Documents <span class="ml-1 text-red-500">*</span>
  </h2>

  <div class="mt-6 space-y-4">
    <div
      class="flex flex-wrap items-center justify-between gap-4 rounded-2xl border border-slate-200 bg-white px-5 py-4"
      *ngFor="let doc of documents.controls; let i = index; trackBy: trackByIndex"
      [formGroup]="doc"
    >
      <div class="flex min-w-[260px] items-center gap-4">
        <div class="h-10 w-10 rounded-xl bg-slate-50 grid place-items-center border border-slate-200">
          <span class="text-xs font-semibold text-slate-500">PDF</span>
        </div>

        <div class="min-w-0 flex items-center gap-3">
          <div class="font-medium text-slate-700">
            {{ doc.get('label')?.value }} <span class="ml-1 text-red-500">*</span>
          </div>
          <div class="text-xs text-slate-400">
            {{ (doc.get('fileTypes')?.value || []).join(', ') | titlecase }} files only
          </div>
          <ng-container *ngIf="doc.get('fileName')?.value">
            <span class="inline-flex h-5 w-5 items-center justify-center rounded-full border border-emerald-600 text-emerald-600">
              <svg
                class="h-3.5 w-3.5"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.2"
              >
                <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            </span>
          </ng-container>
        </div>
      </div>

      <div class="flex min-w-[220px] flex-1 justify-center text-sm">
        <ng-container *ngIf="doc.get('fileName')?.value; else notUploaded">
          <a class="page-link truncate" href="#" (click)="$event.preventDefault()">
            {{ doc.get('fileName')?.value }}
          </a>
        </ng-container>
        <ng-template #notUploaded>
          <span class="inline-flex items-center gap-2 text-slate-400">
            <span class="inline-flex h-5 w-5 items-center justify-center rounded-full border border-red-400 text-red-500">
              <svg
                class="h-3.5 w-3.5"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.2"
              >
                <circle cx="12" cy="12" r="9"></circle>
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 7v6"></path>
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 17h.01"></path>
              </svg>
            </span>
            <span>File not uploaded</span>
          </span>
          <div *ngIf="doc.get('file')?.invalid && (doc.get('file')?.touched || doc.get('file')?.dirty)" class="mt-1 text-xs text-red-500">
            Please upload this document to continue.
          </div>
        </ng-template>
      </div>

      <div class="flex items-center gap-3">
        <input
          type="file"
          class="hidden"
          [id]="'docFile' + i"
          [attr.accept]="doc.get('accept')?.value || null"
          (change)="onFileChange(i, $event)"
        />

        <ng-container *ngIf="!doc.get('fileName')?.value; else removeBtn">
          <label [for]="'docFile' + i" class="page-btn page-btn-secondary cursor-pointer">
            Upload Document
          </label>
        </ng-container>
        <ng-template #removeBtn>
          <button
            type="button"
            class="page-btn border border-red-200 bg-white text-red-600 hover:bg-red-50"
            (click)="removeFile.emit(i)"
          >
            Remove
          </button>
        </ng-template>
      </div>
    </div>
  </div>
</section>
